import Loading from "../../../components/loading";
import { ChartTypeEnum } from "../../../models/chart";
import AdminManageNonPartisanChartForm from "./components/admin-manage-non-partisan-chart-form/admin-manage-non-partisan-chart-form";
import AdminManageNonPartisanChartHeader from "./components/admin-manage-non-partisan-chart-header";
import useAdminManageNonPartisanChart from "./hooks/use-admin-manage-non-partisan-chart";

const AdminManageNonPartisanChart = () => {
	const state = useAdminManageNonPartisanChart(ChartTypeEnum.NON_PARTISAN);

	return (
		<div className="min-h-screen">
			<AdminManageNonPartisanChartHeader />
			{state.loading ? (
				<Loading />
			) : (
				<AdminManageNonPartisanChartForm state={state} />
			)}
		</div>
	);
};

export default AdminManageNonPartisanChart;
